import React from 'react';
import PropTypes from 'prop-types';
import { localizeJsonLD } from '../helper';

const JsonLD = ({ data }) => {
  const mainData = localizeJsonLD(data);

  if (!mainData.id) {
    return null;
  }

  const formatted = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: mainData.title,
    description: mainData.description,
    brand: mainData.school.title,
    image: mainData.image,
    sku: mainData.id,
  };

  if (mainData.price !== undefined) {
    formatted.offers = {
      '@type': 'Offer',
      price: mainData.price,
      priceCurrency: mainData.currency,
      availability: 'http://schema.org/InStock',
    };
  }

  if (mainData.raters_count) {
    formatted.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: mainData.rating,
      reviewCount: mainData.raters_count,
      bestRating: 5,
      worstRating: 0,
    };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(formatted),
      }}
    />
  );
};

JsonLD.propTypes = {
  data: PropTypes.object,
};

JsonLD.defaultProps = {
  data: {},
};

export default JsonLD;
